import React, { memo, useCallback, useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  TextField,
  Grid,
  InputLabel,
  Autocomplete,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-toastify";
import { getLeadSources } from "../../../../redux/leads/getSources.js";
import { useDispatch, useSelector } from "react-redux";
import { useStyles } from "./style";
import {addLead} from "../../../../redux/leads/addLead.js";

function AddLead({ open, setOpen }) {
  const [leadDetail, setLeadDetail] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    source: null,
  });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const classes = useStyles();
 const addLeadState = useSelector((s) => s.leadList.addLead);
  const sources = useSelector((s) => s.leadProfile.sources);

  useEffect(() => {
    if (open) {
      if (!sources?.data?.length) dispatch(getLeadSources());
    }
  }, [dispatch, open]);

  const handleClose = useCallback(() => {setOpen(false);
    setLeadDetail({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    source: null,
    });
  }, [setOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLeadDetail((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleValidation = () => {
    const newErrors = {};
    if (!leadDetail.firstName) newErrors.firstName = "First Name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

   const handleSuccess=()=>{
      toast.success("Lead added successfully", { theme: "colored" });
      handleClose();
   }

   const handleError=(error)=>{
     toast.error(JSON.stringify(error), { theme: "colored" });
   }

  const handleAddLead = () => {
    if (handleValidation()) {
      const payload = {
        firstName: leadDetail.firstName,
        lastName: leadDetail.lastName,
        emails: [
          {
            value: leadDetail.email,
            type: "personal",
            status: "valid",
          },
        ],
        phones: [
          {
            value: leadDetail.phone,
            type: "personal",
            status: "valid",
            bad_number: false,
          },
        ],
        source: leadDetail.source?.name,
      };
      dispatch(addLead({schema:payload,handleSuccess,handleError}));

    }
  };
  return (
    <Dialog
      disablePortal
      sx={{ "& .MuiDialog-container": { mt: "30px" } }}
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Add Lead</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Grid container spacing={2}>
          {/* First/Last Name */}
          <Grid item xs={6}>
            <InputLabel className={classes.inputLabel}>First Name</InputLabel>
            <TextField
              fullWidth
              size="small"
              name="firstName"
              value={leadDetail.firstName}
              onChange={handleChange}
              error={Boolean(errors.firstName)}
              helperText={errors.firstName}
              placeholder="Enter First Name"
            />
          </Grid>
          <Grid item xs={6}>
            <InputLabel className={classes.inputLabel}>Last Name</InputLabel>
            <TextField
              fullWidth
              size="small"
              name="lastName"
              value={leadDetail.lastName}
              onChange={handleChange}
              placeholder="Enter Last Name"
            />
          </Grid>

          {/* Email & Phone */}
          <Grid item xs={6}>
            <InputLabel className={classes.inputLabel}>Email</InputLabel>
            <TextField
              fullWidth
              size="small"
              name="email"
              value={leadDetail.email}
              onChange={handleChange}
              placeholder="Enter Email"
            />
          </Grid>
          <Grid item xs={6}>
            <InputLabel className={classes.inputLabel}>Phone</InputLabel>
            <TextField
              fullWidth
              size="small"
              name="phone"
              value={leadDetail.phone}
              onChange={handleChange}
              placeholder="Enter Phone"
            />
          </Grid>

          <Grid item xs={6}>
            <InputLabel className={classes.inputLabel}>Source</InputLabel>
            <Autocomplete
              fullWidth
              size="small"
              options={sources?.data || []}
              getOptionLabel={(opt) => opt.name || ""}
              value={leadDetail.source}
              onChange={(e, newValue) => {
                setLeadDetail((prev) => ({ ...prev, source: newValue }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select source"
                />
              )}
            />
          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          size="small"
          color="inherit"
          variant="outlined"
        >
          Cancel
        </Button>
        <LoadingButton
          loading={addLeadState.isLoading}
          loadingPosition="end"
          size="small"
          variant="contained"
          color="inherit"
          onClick={handleAddLead}
          className={classes.saveButton}
        >
          Add Lead
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}

export default memo(AddLead);
